import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root {
  --black: #071C21;
  --white-icons-menu: #FDFEFF;
  --light-blue: #75DDFF;
  --dark-blue: #166889;
  --blue: #0A414F;
  --orange: #D99C2B;
  --grey: #CCCCCC;
  --grey-light: #737380;
  --light-grey-btn: #F0F1F2;
  --light-grey-background: #FAFAFA;
  --disabled-btn-header: #CCCCCC;
  --primary-color: ${(props) => props.theme.primary};
  --secondary-color: ${(props) => props.theme.secondary};
}

.primary-color {
  color: var(--primary-color) !important;
}

.secondary-color {
  color: var(--secondary-color) !important;
}`;